// removed by extract-text-webpack-plugin
module.exports = {"container":"_2CtzpPka6unFqSPyaQu5cF","content":"_25mb_Z7lYRvaA0zV5EtjJV","removed":"_3D0fMnY37EQuccNlQoocnU"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Container/style.scss
// module id = 1062
// module chunks = 0